import type { EditorVariable } from './types'

/** A `{{ key }}` placeholder. Spaces optional, because Django accepts it either way. */
const PLACEHOLDER = /(\{\{ *\w+ *\}\})/g

export type TemplateChunk =
  | { text: string; type: 'text' }
  | { key: string; label: string; type: 'variable' }

interface SerializedNode {
  id?: string
  text?: string
  type?: string
}

const nameOf = (placeholder: string) => placeholder.replace(/[{} ]/g, '')

const findVariable = (variables: EditorVariable[], name: string) =>
  variables.find(
    ({ aliases = [], key }) => key === name || aliases.includes(name),
  )

export const splitTemplate = (
  value?: string | null,
  variables: EditorVariable[] = [],
): TemplateChunk[] =>
  (value ?? '')
    .split(PLACEHOLDER)
    .filter(chunk => chunk !== '')
    .map(chunk => {
      const variable = chunk.startsWith('{{')
        ? findVariable(variables, nameOf(chunk))
        : undefined

      return variable
        ? { key: variable.key, label: variable.label, type: 'variable' }
        : { text: chunk, type: 'text' }
    })

export const serializeTemplate = (nodes: SerializedNode[] = []): string =>
  nodes
    .reduce((body, { id, text, type }) => {
      if (type === 'linebreak') return `${body}\n`
      if (type === 'variable') return body + (id ? `{{ ${id} }}` : (text ?? ''))
      return body + (text ?? '')
    }, '')
    .trim()
